import { sourcePlatforms, updateRanks } from "@/mocks/homeData";

export default function SidebarWidgets() {
  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-background-200 bg-background-50">
        <div className="flex items-center justify-between border-b border-background-200 px-4 py-3">
          <span className="flex items-center gap-1.5 font-heading text-sm font-bold text-foreground-950">
            <i className="ri-bar-chart-2-line text-primary-600"></i>
            今日更新榜
          </span>
          <span className="zone-label text-[10px] text-foreground-500">UPDATED</span>
        </div>
        <ul className="divide-y divide-background-200">
          {updateRanks.map((item) => (
            <li key={item.rank}>
              <a href="#archive" className="flex items-start gap-3 px-4 py-2.5 transition-colors hover:bg-background-100">
                <span
                  className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded font-heading text-[11px] font-bold ${
                    item.rank <= 3 ? "bg-primary-500 text-white" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {item.rank}
                </span>
                <span className="flex-1">
                  <span className="block text-xs leading-snug text-foreground-800">{item.title}</span>
                  <span className="mt-1 block text-[10px] text-foreground-500">{item.time}</span>
                </span>
                <span className="rounded bg-accent-100 px-1.5 py-0.5 text-[10px] text-accent-800">{item.trend}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50">
        <div className="flex items-center justify-between border-b border-background-200 px-4 py-3">
          <span className="flex items-center gap-1.5 font-heading text-sm font-bold text-foreground-950">
            <i className="ri-share-forward-line text-primary-600"></i>
            来源平台分布
          </span>
          <span className="zone-label text-[10px] text-foreground-500">SOURCE</span>
        </div>
        <ul className="space-y-2.5 px-4 py-3">
          {sourcePlatforms.map((src) => (
            <li key={src.name} className="flex items-center justify-between text-xs">
              <span className="text-foreground-700">{src.name}</span>
              <span className="font-heading font-bold text-foreground-950">{src.count}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-lg border border-primary-200 bg-primary-50 p-4">
        <div className="flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-600 text-background-50">
            <i className="ri-git-branch-line"></i>
          </span>
          <span className="font-heading text-sm font-bold text-foreground-950">发现新的首发路径？</span>
        </div>
        <p className="mt-2 text-xs leading-relaxed text-foreground-600">
          把最早出现的链接、发布时间与平台信息贴到讨论区，我们会比对时间戳并补充出处。
        </p>
        <a
          href="#discussion"
          className="mt-3 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-3 py-2 text-xs font-medium text-background-50 transition-colors hover:bg-primary-700"
        >
          <i className="ri-chat-new-line"></i>
          前往讨论区投稿
        </a>
      </div>
    </div>
  );
}